"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MilestoneState = void 0;
/**
 * State of a milestone, a milestone state can only represent a single scenario, for example cannot have a locked and
 * unavailable state without creating an entirely new state
 */
var MilestoneState;
(function (MilestoneState) {
    MilestoneState["COMPLETE"] = "COMPLETE";
    MilestoneState["AVAILABLE"] = "AVAILABLE";
    MilestoneState["LOCKED"] = "LOCKED";
    MilestoneState["UNAVAILABLE"] = "UNAVAILABLE";
    MilestoneState["EXPIRED"] = "EXPIRED"; // Milestone has expired
})(MilestoneState = exports.MilestoneState || (exports.MilestoneState = {}));
